import type { App } from "vue";
import { gettext } from "@/services/translation";

export default {
  install(app: App) {
    app.use(gettext);
  },
};
